module.exports = __webpack_public_path__ + "img/medMission_041022_H.8bf925b4.jpg";